// networking/ws.constants.ts — WebSocket handler constants
// Centralized constants for message handling to eliminate magic numbers

export const TOAST_DURATION_SHORT = 2000;
export const TOAST_DURATION_NORMAL = 3000;
export const TOAST_DURATION_LONG = 4000;
export const TOAST_DURATION_VERY_LONG = 5000;
export const TOAST_DURATION_EXTRA_LONG = 10000;

export const DEFAULT_POSITION = 0;
export const DEFAULT_VELOCITY = 0;
export const DEFAULT_ROTATION = 0;
export const DEFAULT_ANGULAR_VELOCITY = 0;
export const DEFAULT_SCALE = 1.0;
export const DEFAULT_MULTIPLIER = 1.0;
export const DEFAULT_TIMESTAMP = 0;
export const DEFAULT_PELLETS_COLLECTED = 0;
export const DEFAULT_KILLS = 0;
export const DEFAULT_DEATHS = 0;

export const VISIBILITY_MARGIN_DEFAULT = 200;
export const VISIBILITY_MARGIN_LARGE = 300;

export const TWO_PI = Math.PI * 2;
